// extracted by mini-css-extract-plugin
export default {"container":"Pagina404_container__oQRcd","link":"Pagina404_link__b3tn7"};